import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlankDialogComponent } from './blank-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    BlankDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule
  ],
  exports: [
    BlankDialogComponent
  ]
})
export class BlankDialogModule { }
